module.exports = __webpack_public_path__ + "img/ONiAd-Academy-imagen-1.95b3bfdc.png";